import React, { useState, useEffect } from "react";

const HeaderImageUploader = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Load from localStorage
  useEffect(() => {
    const storedImage = localStorage.getItem("headerImage");
    if (storedImage) {
      setImagePreview(storedImage);
    }
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "image/jpeg") {
      alert("Only JPG images are allowed.");
      return;
    }

    setSelectedFile(file);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      alert("Please select a JPG file first.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result;
      setImagePreview(base64Image);
      localStorage.setItem("headerImage", base64Image);
      setSelectedFile(null);
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleClear = () => {
    localStorage.removeItem("headerImage");
    setImagePreview(null);
    setSelectedFile(null);
  };

  return (
    <div className="container mt-4">
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <div className="card ">
                <div className="card-body text-center">
                  <img
                    src={
                      imagePreview ||
                      "https://via.placeholder.com/600x150?text=No+Header+Image"
                    }
                    alt="Header"
                    className="img-fluid mb-3"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                  <h5 className="text-center mb-3">Size W 2200px X H 220px</h5>

                  <input
                    type="file"
                    accept="image/jpeg"
                    className="form-control mb-3"
                    onChange={handleFileChange}
                  />

                  <button
                    className="btn btn-primary w-100 mb-3"
                    onClick={handleUpload}
                  >
                    Upload Header Image (JPG only)
                  </button>

                  <button
                    className="btn btn-danger w-100"
                    onClick={handleClear}
                    disabled={!imagePreview}
                  >
                    Clear Image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default HeaderImageUploader;
